import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class BMICalc extends kr.Component {
    init() {
        this._form = this.$element.querySelector('.js-form');
        this._charItems = this.$element.querySelectorAll('.js-char-item');
        this._products = this.$element.querySelectorAll('.js-product');
        this._bind();
    }

    _bind() {
        this._form.addEventListener('submit', event => {
            event.preventDefault();
            const formData = new FormData(this._form);
            const weight = formData.get('weight');
            const height = formData.get('height');
            const bmi = this.getBMI(weight, height);
            const bmiGroup = this.getBMIGroup(bmi);
            this.$element.querySelector('.js-bmi-value').innerHTML = `${bmi.toFixed(2)} BMI`;
            this.$element.querySelector('.js-bmi-text').innerHTML = `${window.bmi_grupa[bmiGroup]}`;
            this._charItems.forEach(item => {
                const attr = item.getAttribute('data-group');
                if (attr.includes(bmiGroup)) {
                    HTMLClass.addClass(item, 'active');
                } else {
                    HTMLClass.removeClass(item, 'active');
                }
            });
            this._products.forEach(item => {
                const attr = item.getAttribute('data-group');
                if (attr.includes(bmiGroup)) {
                    HTMLClass.addClass(item, 'active');
                } else {
                    HTMLClass.removeClass(item, 'active');
                }
            });
            this.$element.querySelector('.js-bmicalc--tips').innerHTML = `<p>${window.bmi_zalecenia[bmiGroup]}</p>`;
            
            HTMLClass.addClass(this.$element, 'bmicalc--calced');
            setTimeout(() => {
                HTMLClass.addClass(this.$element, 'bmicalc--calced--show');
            }, 300);

            if (window.innerWidth < 993) {
                window.scrollTo({
                    top: this.$element.querySelector('.js-col-result').offsetTop - 200, 
                    behavior: 'smooth'
                });
            }
        });
    }

    getBMI(weight, height) {
        return weight / (height * height) * 10000;
    }

    getBMIGroup(bmi) {
        let bmiGroup = "wyglodzenie";
        if (bmi < 16) {
        } else if (bmi >= 16 && bmi <= 16.99) {
            bmiGroup = "wychudzenie";
        } else if (bmi >= 17 && bmi <= 18.49) {
            bmiGroup = "niedowaga";
        } else if (bmi >= 18.5 && bmi <= 24.99) {
            bmiGroup = "ok";
        } else if (bmi >= 25 && bmi <= 29.99) {
            bmiGroup = "nadwaga";
        } else if (bmi >= 30 && bmi <= 34.99) {
            bmiGroup = "otylosc_1";
        } else if (bmi >= 35 && bmi <= 39.99) {
            bmiGroup = "otylosc_2";
        } else {
            bmiGroup = "otylosc_max";
        }

        return bmiGroup;
    }
}

kr.registerComponent('.js-bmicalc', {
    component: BMICalc
});